<template>
  <section class="live-controls btn-group btn-group-sm mr-1">
    <button
      class="btn btn-primary"
      @click="startLive"
      :disabled="room.status !== 'READY'">
      라이브시작
    </button>
    <button
      class="btn btn-primary"
      @click="computeWinners"
      :disabled="room.status !== 'QUIZ'">
      우승자선정
    </button>
    <button
      class="btn btn-primary"
      @click="endLive"
      :disabled="room.status == 'READY'">
      라이브종료
    </button>
  </section>
</template>

<script>
import {
  // mapGetters,
  mapState
} from 'vuex'

export default {
  name: 'RoomControls',

  date () {
    return {
    }
  },

  computed: {
    ...mapState('room', [
      'room'
    ]),
    stopMsg () {
      if (this.isCast) {
        return '!!!방송종료'
      } else {
        return '시청종료'
      }
    }
  },

  methods: {
    stop () {
      this.$store.commit('room/setRoomType', null)
    },

    startLive () {
      this.$store.dispatch('room/startLive')
    },

    computeWinners () {
      this.$store.dispatch('room/computeWinners')
    },

    endLive () {
      this.$store.dispatch('room/endLive')
      this.$router.push({ name: 'home' })
    }

  }
}
</script>

<style scoped>
</style>
